export default class RetriableError extends Error {
    message: string
    label: string
    code: string

    constructor(message: string, code: string, label: string) {
        super(message)
        this.message = message
        this.code = code
        this.label = label
    }
}
